import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../api";

export default function AssignReasoningToMega() {
  const { examId } = useParams();
  const nav = useNavigate();

  const [questions, setQuestions] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    loadQuestions();
  }, []);

  const loadQuestions = async () => {
    const res = await api.get("/admin/reasoning-questions");
    setQuestions(res.data || []);
  };

  const toggle = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const save = async () => {
    try {
      await api.post(`/admin/mega-exam/reasoning`, {
        exam_id: examId,
        reasoning_question_ids: selected
      });
      alert("Reasoning added to Mega Exam");
      nav("/admin/mega-scholarship-list");
    } catch {
      alert("Save failed");
    }
  };

  return (
    <div style={{ padding: 40 }}>
      <h1>Add Reasoning – Mega Exam #{examId}</h1>

      <div style={{ display: "grid", gap: 12 }}>
        {questions.map((q) => (
          <label key={q.id} style={{ border: "1px solid #ccc", padding: 12 }}>
            <input
              type="checkbox"
              checked={selected.includes(q.id)}
              onChange={() => toggle(q.id)}
            />
            <img src={`/${q.image_url}`} style={{ width: 120 }} />
          </label>
        ))}
      </div>

      <button
        onClick={save}
        style={{
          marginTop: 30,
          padding: "14px 40px",
          background: "#16a34a",
          color: "white",
          borderRadius: 10,
          fontSize: 18
        }}
      >
        Save Reasoning
      </button>
    </div>
  );
}
